export enum Status {
    ACTIVE = 1,
    DEACTIVATED = 2,
}
